import type { EventEnvelope } from "@orderman/shared";
import { outboxAdd, outboxAll, outboxDelete, type OutboxRecord } from "./idb.js";

/** Outbox = persistente Warteschlange der noch nicht bestätigten Events. */

export function enqueue(events: EventEnvelope[]): Promise<unknown> {
  return Promise.all(events.map((e) => outboxAdd(e)));
}

export function pending(): Promise<OutboxRecord<EventEnvelope>[]> {
  return outboxAll<EventEnvelope>();
}

export function ack(seqs: number[]): Promise<void> {
  return outboxDelete(seqs);
}
